/** Site-wide sans-serif stack (matches Google Fonts load in public/index.html). */
export const SITE_FONT_FAMILY =
    '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
